/**
 * Onglets des écrans de détail du lot L5. L'onglet actif vit dans l'URL (`?tab=`), comme dans les
 * aires Accès et Données : une capture ou un lien pointe sur l'onglet voulu.
 */
export function defineTabs<const T extends readonly string[]>(ids: T) {
  return {
    ids,
    is: (value: unknown): value is T[number] => typeof value === 'string' && ids.includes(value),
    parse: (value: unknown): T[number] =>
      typeof value === 'string' && ids.includes(value) ? (value as T[number]) : ids[0]!,
  };
}

export const QUOTA_TABS = defineTabs(['summary', 'increase'] as const);
export type QuotaTab = (typeof QUOTA_TABS.ids)[number];

export const TICKET_TABS = defineTabs(['summary', 'definition'] as const);
export type TicketTab = (typeof TICKET_TABS.ids)[number];

export const FIREWALL_RULE_TABS = defineTabs(['summary', 'definition'] as const);
export type FirewallRuleTab = (typeof FIREWALL_RULE_TABS.ids)[number];

export const INFRASTRUCTURE_TABS = defineTabs([
  'summary',
  'capacity',
  'services',
  'instanceTypes',
  'check',
  'definition',
  'access',
] as const);
export type InfrastructureTab = (typeof INFRASTRUCTURE_TABS.ids)[number];

export const INSTANCE_TYPE_TABS = defineTabs(['summary', 'infrastructures'] as const);
export type InstanceTypeTab = (typeof INSTANCE_TYPE_TABS.ids)[number];

export const RUNTIME_TABS = defineTabs(['summary', 'versions', 'builds'] as const);
export type RuntimeTab = (typeof RUNTIME_TABS.ids)[number];

export const DEVICE_TABS = defineTabs(['summary', 'definition', 'access'] as const);
export type DeviceTab = (typeof DEVICE_TABS.ids)[number];

export const BRIDGE_TABS = defineTabs(['summary', 'definition', 'configuration', 'access'] as const);
export type BridgeTab = (typeof BRIDGE_TABS.ids)[number];

export const STREAM_TABS = defineTabs(['summary', 'definition', 'access'] as const);
export type StreamTab = (typeof STREAM_TABS.ids)[number];

export const WORKSPACE_TABS = defineTabs([
  'summary',
  'usage',
  'logs',
  'files',
  'definition',
  'access',
] as const);
export type WorkspaceTab = (typeof WORKSPACE_TABS.ids)[number];

export const ENDPOINT_TABS = defineTabs([
  'summary',
  'usage',
  'logs',
  'test',
  'definition',
  'access',
] as const);
export type EndpointTab = (typeof ENDPOINT_TABS.ids)[number];
